import { render, staticRenderFns } from "./automaticServer.vue?vue&type=template&id=36482694&scoped=true&"
import script from "./automaticServer.vue?vue&type=script&lang=js&"
export * from "./automaticServer.vue?vue&type=script&lang=js&"
import style0 from "./automaticServer.vue?vue&type=style&index=0&id=36482694&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36482694",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\work\\admin\\datacenter_web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('36482694')) {
      api.createRecord('36482694', component.options)
    } else {
      api.reload('36482694', component.options)
    }
    module.hot.accept("./automaticServer.vue?vue&type=template&id=36482694&scoped=true&", function () {
      api.rerender('36482694', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/gmTool/automaticServer/automaticServer.vue"
export default component.exports